export const contractEnvVar = () => {
  let envVar = ''
  switch (process.env.REACT_APP_LOCAL_DB) {
    case 'local':
      envVar = '- Local'
      break
    case 'azure':
      envVar = '- Dev'
      break
    case 'demo':
      envVar = '- Demo'
      break
    case 'staging':
      envVar = '- Staging'
      break
    case 'uat':
      envVar = '- UAT'
      break
    default:
      envVar = ''
      break
  }
  return envVar
}

// Prod gate for the listing improvements (cache-first ledger screens, tile entrance):
// react-component's contract-v6 is shared by every environment, so prod keeps the old
// behaviour until the change is signed off. Same check as contract-react's isProd.
export const isProdEnv = () =>
  process.env.REACT_APP_LOCAL_DB === 'prod' ||
  process.env.REACT_APP_LOCAL_DB === 'prod2'

// ledger listing / header queries: silent refresh everywhere but prod
export const ledgerFetchPolicy: 'network-only' | 'cache-and-network' = isProdEnv()
  ? 'network-only'
  : 'cache-and-network'
